// Section 19 and 14: Travellers seeking work. 6% per season, Summer bias; more often above trust
// 75, half as often under founders-first, never at the population cap. 1 to 3 unrelated adults,
// each skilled (one job at 3 to 4.5): the main way to gain rare skills mid-game. What they claim is
// true 80% of the time. The gate asks or the migration policy decides.
// Constants: config.events.travellers, config.migration.
import type { Config } from '../../config';
import {
  arrivalChoices,
  arrivalRoom,
  arrivalWeight,
  eventEntry,
  eventRng,
} from '../../core/content-helpers';
import { defineEvent, noModifiers } from '../../core/registry';
import type { ReadContext } from '../../core/types';

export function travellers(config: Config) {
  const c = config.events.travellers;
  const plan = (ctx: ReadContext): { size: number; seed: number } => {
    const rng = eventRng(ctx, 'travellers', 'plan');
    const size = Math.min(rng.int(c.minSize, c.maxSize), arrivalRoom(ctx));
    return { size, seed: Math.floor(rng.float() * 4294967296) >>> 0 };
  };
  return defineEvent({
    id: 'travellers',
    label: 'Travellers seeking work',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['summer'],
    foreshadow: null,
    ledgerTag: 'gate',
    weight: (ctx) => arrivalWeight(ctx, c.baseChance),
    text: (ctx) => eventEntry('travellers', { size: plan(ctx).size }),
    apply: (ctx) => {
      const p = plan(ctx);
      if (p.size <= 0) return [];
      return [
        {
          kind: 'arrivals',
          spec: {
            eventId: 'travellers',
            reason: 'work',
            size: p.size,
            composition: 'adults',
            skilled: { skill: null, min: c.skillMin, max: c.skillMax },
            claims: null,
            seed: p.seed,
          },
        },
      ];
    },
    choices: arrivalChoices('travellers', {
      'admit-all': { id: 'admit-all', label: 'Admit them' },
      'admit-some': { id: 'admit-some', label: 'Admit some' },
      guests: { id: 'guests', label: 'Admit as guests' },
      'turn-away': { id: 'turn-away', label: 'Turn them away' },
    }),
    modifierTargets: [],
    modifiers: noModifiers,
  });
}
